import { IDeleteFuncionarioImageByIdUseCase } from "../../../presentation/useCases/delete/delete_funcionario_image_by_id_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFuncionarioImageByIdUseCase
 */

export class DeleteFuncionarioImageByIdUseCase implements IDeleteFuncionarioImageByIdUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteFuncionarioImageById(
    idFuncionario: number,
  ): Promise<void> {
    await this.repository.deleteFuncionarioImageById(idFuncionario);
  }
}
